var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{ref:"map",style:(_vm.mapStyle),attrs:{"center":_vm.center,"zoom":_vm.zoomValue,"options":_vm.mapOptions},on:{"boundsChanged":function($event){return _vm.$emit('boundsChanged')},"idle":_vm.centerOnLoad}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }